/**
 * CGStep pure components.
 *
 * These components are platform-agnostic and can be used in Next.js, Electron, or any React app.
 */

// Step type data
export {
  selectableCadenceStepsList,
  cadenceStepsList,
  triggerSteps,
  linkedinStepsList,
  emailStepsList,
  connectStep,
  messageStep,
  inmailStep,
  visitStep,
  emailStep,
  reminderStep,
  callStep,
  voiceNoteStep,
  likeRecentPostsStep,
  followStep,
  siftStep,
  type CadenceStepItem,
} from './stepData';

// Types
export type {
  CadenceStepStatePure,
  CadenceStepTypePure,
  SiftConditionPure,
  SiftConfigPure,
  TemplateStepPure,
  CadenceStepNodePure,
  CadenceGraphNodesPure,
  CGStepUserTeamPure,
  CGStepDocumentPure,
  DifferentFromTemplatePure,
  StepCreateInputPure,
  StepUpdateInputPure,
} from './types';
export { SIFT_FIELD_OPTIONS_PURE, SIFT_OPERATOR_LABELS_PURE } from './types';

// Pure components - Small utilities
export { YesNoSwitchPure, type YesNoSwitchPureProps } from './YesNoSwitchPure';
export { CGLeafCountPure, type CGLeafCountPureProps } from './CGLeafCountPure';

// Pure components - Content
export {
  CTSContentEditingPure,
  type CTSContentEditingPureProps,
  type StepType,
  type StepData,
  type StepErrors,
  type SiftConfig,
} from './CTSContentEditingPure';

// Edit-state types + helper (formerly co-located with the legacy
// CGAddStepPure JSX components, which were retired in favour of
// CampaignDayCardPure's inline editor).
export {
  daysToMs,
  type EditStepPure,
  type EditAddStepPure,
  type EditDelayStepPure,
  type EditContentStepPure,
  type CreateStepData,
  type CadenceStepOption,
} from './CGAddStepPure';

// Pure components - Step nodes
export { CGDelayStepPure, type CGDelayStepPureProps } from './CGDelayStepPure';
export { CGWaitForStepPure, type CGWaitForStepPureProps } from './CGWaitForStepPure';

// Main CGStep component
export { CGStepPure, type CGStepPureProps } from './CGStepPure';
